import { FunctionComponent } from 'react';
import { Stack } from 'components/Stack';
import imgIconSVG from 'icons/img.svg';
import { ReturnProof } from '@pperform/pp-data-mappers';
import downloadIconSVG from 'icons/download.svg';
import { ReactSVG } from 'react-svg';
import { useTranslation } from 'react-i18next';
import {
  ImgName,
  DownLoadLink,
  NoShrinkWrapper,
  AttachmentItemSection,
} from './AttachmentItem.styles';

interface AttachmentProps {
  attachment: ReturnProof;
}

const AttachmentItem: FunctionComponent<AttachmentProps> = ({
  attachment,
}): JSX.Element => {
  const { t } = useTranslation();

  return (
    <AttachmentItemSection
      isFullWidth
      align="center"
      justify="space-between"
      gap={16}
    >
      <Stack direction="row" align="center" justify="flex-start" gap={10}>
        <NoShrinkWrapper>
          <ReactSVG src={imgIconSVG} aria-hidden />
        </NoShrinkWrapper>
        <ImgName id="download-attachment-name">{attachment.fileName}</ImgName>
      </Stack>
      <NoShrinkWrapper>
        <DownLoadLink
          href={attachment.url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={t('ALT_TEXT_DOWNLOAD_ATTACHMENT_LINK')}
          aria-labelledby="download-attachment-name"
        >
          <ReactSVG src={downloadIconSVG} aria-hidden />
        </DownLoadLink>
      </NoShrinkWrapper>
    </AttachmentItemSection>
  );
};

export { AttachmentItem };
